<div
  class="row m-0 personal-info credit-app-body"
  [ngClass]="{'pl-4 pr-4': !isBuyNow && !isLegacyCreditApp}"
>
  <form novalidate [formGroup]="personalInfoForm" class="col-12 scrollDiv">
    <h1 class="row mx-0 personal-info-title an-h-line-height" *ngIf="type === 'buyer' && !isLegacyCreditApp">
      {{ SCData?.Title }}
    </h1>
    <h1 class="row mx-0 personal-info-title legacy-ca-tile an-h-line-height" *ngIf="type === 'buyer' && isLegacyCreditApp">
      {{ legacyCaTitle }}
    </h1>
    <h1 class="row mx-0 personal-info-title  an-h-line-height" *ngIf="type === 'coBuyer'">
      {{ SCData?.CoBuyerTitle }}
    </h1>
    <p
      class='row mx-0 personal-info-subheader' *ngIf='isBuyNow && this.creditAppConfigData?.PreQualificationInformation?.PrequalSubheader && type === "buyer"'>
    {{ this.creditAppConfigData.PreQualificationInformation.PrequalSubheader }}</p>
    <div class="row mx-0" [ngClass]="{ 'form-col-buy-now': isBuyNow || isLegacyCreditApp, 'form-col': !isBuyNow && !isLegacyCreditApp }">
      <!-- *************************** First Name Start ***************************  -->
      <div
        class="pl-0 custom-col f-name fname-col"
      >
        <label class="an-p-line-height" for="first_name">{{ SCData?.FirstNameLabel }}</label>
        <input
          id="first_name"
          class="form-control w-100"
          formControlName="FirstName"
          maxlength="15"
          type="text"
          (focus)="scrollInto($event)"
          [readonly]="isFirstNameReadOnly"
          [ngClass]="{
            error:
              (personalInfoForm.get('FirstName').touched ||
                personalInfoForm.get('FirstName').dirty) &&
              !personalInfoForm.get('FirstName').valid
          }"
        />
        <button tabindex="0" aria-label="Clear first name" *ngIf="
          (personalInfoForm.get('FirstName').touched ||
          personalInfoForm.get('FirstName').dirty) &&
          !personalInfoForm.get('FirstName').valid"
         class="form-error-x dt-icon dt-icon-input-clear mt-4"
          (click)="personalInfoForm.get('FirstName').reset()"
          (keyup)="$event?.keyCode === 13
              ? personalInfoForm.get('FirstName').reset()
              : null">
        </button>
        <div class="invalid-feedback d-block">
          <span
            class="form-validator_error"
            *ngIf="
              (personalInfoForm.get('FirstName').touched ||
                personalInfoForm.get('FirstName').dirty) &&
              !personalInfoForm.get('FirstName').valid
            "
          >
            <ng-container
              *ngIf="
                !!personalInfoForm.get('FirstName').errors?.required;
                else second
              "
            >
              {{ SCData?.FirstNameRequired }}
            </ng-container>
            <ng-template #second>
              <ng-container
                *ngIf="
                  !!personalInfoForm.get('FirstName').errors?.minlength;
                  else third
                "
              >
                {{ SCData?.FirstNameInvalid }}
              </ng-container>
              <ng-template #third>
                <ng-container
                  *ngIf="!!personalInfoForm.get('FirstName').errors?.pattern"
                >
                  {{ SCData?.FirstNameInvalid }}
                </ng-container>
              </ng-template>
            </ng-template>
          </span>
        </div>
      </div>
      <!-- *************************** First Name End ***************************  -->
      <!-- *************************** Middle Name Start ***************************  -->
      <div
        class="mi-col custom-col nidinitial mi-col ml-0"
      >
        <label class="an-p-line-height" for="MiddleName">{{ SCData?.MILabel }}</label>
        <input
          class="form-control w-100"
          formControlName="MI"
          maxlength="1"
          type="text"
          (focus)="scrollInto($event)"
          id="MiddleName"
          [readonly]="isMiddleNameReadOnly"
          [ngClass]="{
            error:
              (personalInfoForm.get('MI').touched ||
                personalInfoForm.get('MI').dirty) &&
              !personalInfoForm.get('MI').valid
          }"
        />

        <button tabindex="0" aria-label="Clear middle name" *ngIf="
        (personalInfoForm.get('MI').touched ||
        personalInfoForm.get('MI').dirty) &&
        !personalInfoForm.get('MI').valid"
        class="form-error-x dt-icon dt-icon-input-clear mt-4"
        (click)="personalInfoForm.get('MI').reset()"
        (keyup)="$event?.keyCode === 13
            ? personalInfoForm.get('MI').reset()
            : null">
      </button>
      
        <div class="invalid-feedback d-block">
          <span
            class="form-validator_error"
            *ngIf="
              (personalInfoForm.get('MI').touched ||
                personalInfoForm.get('MI').dirty) &&
              !personalInfoForm.get('MI').valid
            "
          >
            {{ SCData?.MIInvalid }}
          </span>
        </div>
      </div>
      <!-- *************************** Middle Name End ***************************  -->
      <!-- *************************** Last Name Start ***************************  -->
      <div
        class="custom-col l-name lname-col"
      >
        <label class="an-p-line-height" for="lastNameId">{{ SCData?.LastNameLabel }}</label>
        <input
          class="form-control w-100 pr-5"
          maxlength="35"
          id="lastNameId"
          type="text"
          (focus)="scrollInto($event)"
          formControlName="LastName"
          [readonly]="isLastNameReadOnly"
          [ngClass]="{
            error:
              (personalInfoForm.get('LastName').touched ||
                personalInfoForm.get('LastName').dirty) &&
              !personalInfoForm.get('LastName').valid
          }"
        />
        <button aria-label="Clear last name" *ngIf="
          (personalInfoForm.get('LastName').touched ||
          personalInfoForm.get('LastName').dirty) &&
          !personalInfoForm.get('LastName').valid"
          tabindex="0" class="form-error-x dt-icon dt-icon-input-clear mt-4"  
          (click)="personalInfoForm.get('LastName').reset()"
          (keyup)="$event?.keyCode === 13
              ? personalInfoForm.get('LastName').reset()
              : null">
        </button>

        <div class="invalid-feedback d-block">
          <span
            class="form-validator_error"
            *ngIf="
              (personalInfoForm.get('LastName').touched ||
                personalInfoForm.get('LastName').dirty) &&
              !personalInfoForm.get('LastName').valid
            "
          >
            <ng-container
              *ngIf="
                !!personalInfoForm.get('LastName').errors?.required;
                else second
              "
            >
              {{ SCData?.LastNameRequired }}
            </ng-container>
            <ng-template #second>
              <ng-container
                *ngIf="
                  !!personalInfoForm.get('LastName').errors?.minlength;
                  else third
                "
              >
                {{ SCData?.LastNameInvalid }}
              </ng-container>
              <ng-template #third>
                <ng-container
                  *ngIf="!!personalInfoForm.get('LastName').errors?.pattern"
                >
                  {{ SCData?.LastNameInvalid }}
                </ng-container>
              </ng-template>
            </ng-template>
          </span>
        </div>
      </div>
      <!-- *************************** Last Name End ***************************  -->
      <!-- *************************** Email Start ***************************  -->
      <div
        class="mailcol custom-col email-col"
      >
        <label class="an-p-line-height" for="email">{{ SCData?.EmailLabel }}
          <span class="email-tooltip"  *ngIf="isLoggedIn && personalInfo?.emailAddress">
            <span class="feature-text" id="emailTooltip-Content">
              <span class="tooltiptext" id="emailTooltip">Forms submitted while you are logged in are tied to your account. If you would like to change the email address used in this form, please log out and try again.</span>
              <span class="tooltipx dt-icon dt-icon-question-mark vhtooltip-style"></span>
            </span>
          </span>
        </label>
        <input
          class="form-control w-100 pr-5"
          type="text"
          formControlName="Email"
          id="email"
          maxlength="40"
          (focus)="scrollInto($event)"
          (blur)="checkEmailDomain()"
          [readonly]="(isLoggedIn && personalInfo?.emailAddress) || isEmailAddressReadOnly"
          [ngClass]="{
            error:
              (personalInfoForm.get('Email').touched ||
                personalInfoForm.get('Email').dirty) &&
              !personalInfoForm.get('Email').valid
          }"
        />
        <div role="alert" aria-live="polite"
          *ngIf="showEmailSuggestion && emailSuggestion"
          class="email-suggestion-message">
          <span class="email-suggestion-text">Did you mean:</span>
          <button class="email-suggestion-badge"
            (click)="acceptEmailSuggestion()"
            (keyup.enter)="acceptEmailSuggestion()"
            [attr.aria-label]="'Update email domain to ' + emailSuggestion">
            <span class="email-suggestion-address">{{ emailSuggestion }}</span>
            <span class="email-suggestion-icon-wrapper">
              <span class="email-suggestion-icon"></span>
            </span>
          </button>
        </div>
        <button tabindex="0" aria-label="Clear email address" *ngIf="
          (personalInfoForm.get('Email').touched ||
          personalInfoForm.get('Email').dirty) &&
          !personalInfoForm.get('Email').valid"
          class="form-error-x dt-icon dt-icon-input-clear mt-4"
          (click)="personalInfoForm.get('Email').reset()"
          (keyup)="$event?.keyCode === 13
              ? personalInfoForm.get('Email').reset()
              : null">
        </button>
        
        <div class="invalid-feedback d-block">
          @if (leadValidation_EmailInvalid) {
             <span class="form-validator_error">
              <ng-container >
                {{ SCData?.LeadValidation_EmailInvalid || 'Please use a valid email.' }}
              </ng-container>
            </span>            
          }
          @else {
            <span
              class="form-validator_error"
              *ngIf="
                (personalInfoForm.get('Email').touched ||
                  personalInfoForm.get('Email').dirty) &&
                !personalInfoForm.get('Email').valid
              "
            >
              <ng-container
                *ngIf="
                  !!personalInfoForm.get('Email').errors?.required;
                  else second
                "
              >
                {{ SCData?.EmailRequired }}
              </ng-container>
              <ng-template #second>
                <ng-container *ngIf="!personalInfoForm.get('Email').valid">
                  {{ SCData?.EmailInvalid }}
                </ng-container>
              </ng-template>
            </span>            
          }


        </div>
      </div>
      <!-- *************************** Email End ***************************  -->
      <!-- *************************** phone number Start ***************************  -->
      <div
        class="custom-col tel phone-col"
        [ngClass]="{
          'order-5': type === 'coBuyer'
        }"
      >
        <label class="an-p-line-height" for="phone">{{ SCData?.PhoneLabel }}</label>
        <input
          class="form-control w-100"
          formControlName="Phone"
          id="phone"
          type="text"
          placeholder="(___)___-____"
          [dtTextMask]="{ mask: phoneMask, guide: true }"
          (focus)="scrollInto($event)"
          (focusout)="phoneFocusOut()"
          [readonly]="isPhoneReadOnly"
          [ngClass]="{
            error:
              (personalInfoForm.get('Phone').touched ||
                personalInfoForm.get('Phone').dirty) &&
              (!!personalInfoForm.get('Phone').invalid || !!personalInfoForm.get('Phone').errors?.invalidAreaCode)
          }"
        />
        <button tabindex="0" aria-label="Clear phone number" *ngIf="
        (personalInfoForm.get('Phone').touched ||
        personalInfoForm.get('Phone').dirty) &&
        !personalInfoForm.get('Phone').valid"
        class="form-error-x dt-icon dt-icon-input-clear mt-4"
        (click)="personalInfoForm.get('Phone').reset()"
        (keyup)="$event?.keyCode === 13
            ? personalInfoForm.get('Phone').reset()
            : null">
      </button>

        <div class="invalid-feedback d-block">
           @if(leadValidation_PhoneInvalid) {
            <span class="form-validator_error">
              <ng-container>
                {{ SCData?.LeadValidation_PhoneInvalid || 'Please use a valid phone number' }}
              </ng-container>
            </span>
           }
           @else {
            <span
              class="form-validator_error"
              *ngIf="
                (personalInfoForm.get('Phone').touched ||
                  personalInfoForm.get('Phone').dirty) &&
                (!!personalInfoForm.get('Phone').invalid || !!personalInfoForm.get('Phone').errors?.invalidAreaCode)
              "
            >
              <ng-container *ngIf="personalInfoForm.get('Phone').errors?.invalidAreaCode else second">
                {{ creditAppConfigData?.PreQualificationInformation?.PhoneInvalidAreaCode }}
              </ng-container>
              <ng-template #second>
                <ng-container *ngIf="!personalInfoForm.get('Phone').valid">
                  {{ SCData?.PhoneInvalid }}
                </ng-container>
              </ng-template>
            </span>            
           }




        </div>
      </div>
      <!-- *************************** phone number End ***************************  -->
      <!-- *************************** Relationship to primary applicant ***************************  -->
      <div
        class="rel-to-prim-app-col custom-col"
        [ngClass]="{
          'order-7 order-lg-6': type === 'coBuyer'
        }"
        *ngIf="type === 'coBuyer'"
      >
        <label class="an-p-line-height" for="relationship_to_primary_applicant">{{ SCData?.CoBuyerRelationshipToPrimaryApplicantLabel }}</label>
        <select
          class="form-control w-100 gradient"
          id="relationship_to_primary_applicant"
          formControlName="RelationshipToPrimaryApplicant"
          [ngClass]="{
            error:
              !personalInfoForm.get('RelationshipToPrimaryApplicant').valid &&
              (personalInfoForm.get('RelationshipToPrimaryApplicant').touched ||
                personalInfoForm.get('RelationshipToPrimaryApplicant').dirty)
          }"
        >
          <option
            value=""
            [selected]="
              personalInfoForm.get('RelationshipToPrimaryApplicant').value ===
                '' ||
              this.personalInfoForm.get('RelationshipToPrimaryApplicant')
                .value === null
            "
          >
            {{ creditAppConfigData?.SelectsDefaultLabel }}
          </option>
          <option
            *ngFor="
              let relationshipToPrimaryApplicant of relationshipToPrimaryApplicants
            "
            [value]="relationshipToPrimaryApplicant.Description"
          >
            {{ relationshipToPrimaryApplicant?.Value }}
          </option>
        </select>
        <div class="invalid-feedback d-block">
          <span
            class="form-validator_error"
            *ngIf="
              !personalInfoForm.get('RelationshipToPrimaryApplicant').valid &&
              (personalInfoForm.get('RelationshipToPrimaryApplicant').touched ||
                personalInfoForm.get('RelationshipToPrimaryApplicant').dirty)
            "
          >
            <ng-container
              *ngIf="
                !!personalInfoForm.get('RelationshipToPrimaryApplicant').errors
                  ?.required
              "
            >
              {{ SCData?.CoBuyerRelationshipToPrimaryApplicantRequired }}
            </ng-container>
          </span>
        </div>
      </div>
      <!-- *************************** Relationship to primary applicant ***************************  -->
      <!-- *************************** DOB Start ***************************  -->
      <div 
        class="custom-col dob-col"
        [ngClass]="{
          'order-6 order-lg-7 dob-cobuyer-col': type === 'coBuyer'
        }"
      >
        <label class="an-p-line-height" for="dob"> {{ SCData?.DOBLabel }}</label>
        <input
          type="text"
          class="form-control w-100"
          formControlName="DOB"
          id="dob"
          placeholder="MM/DD/YYYY"
          (focus)="scrollInto($event)"
          [ngClass]="{
            error:
              (personalInfoForm.get('DOB').touched ||
                personalInfoForm.get('DOB').dirty) &&
              (!!personalInfoForm.get('DOB').invalid ||
                !!personalInfoForm.get('DOB').errors?.invalidDOB)
          }"
          [dtTextMask]="{ mask: dobMask, guide: true }"
        />
        <button tabindex="0" aria-label="Clear date of birth" *ngIf="
          (personalInfoForm.get('DOB').touched ||
          personalInfoForm.get('DOB').dirty) &&
          !personalInfoForm.get('DOB').valid"
          class="form-error-x dt-icon dt-icon-input-clear mt-4"
          (click)="personalInfoForm.get('DOB').reset()"
          (keyup)="$event?.keyCode === 13
            ? personalInfoForm.get('DOB').reset()
            : null">
        </button>

        <div class="invalid-feedback d-block">
          <span
            class="form-validator_error"
            *ngIf="
              (personalInfoForm.get('DOB').touched ||
                personalInfoForm.get('DOB').dirty) &&
              (!personalInfoForm.get('DOB').valid ||
                !!personalInfoForm.get('DOB').errors?.invalidDOB)
            "
          >
            <ng-container
              *ngIf="
                !personalInfoForm.get('DOB').errors?.valid ||
                !!personalInfoForm.get('DOB').errors?.invalidDOB
              "
            >
              {{ SCData?.DOBInvalid }}
            </ng-container>
          </span>
        </div>
      </div>
      <!-- *************************** DOB End ***************************  -->

      <!-- *************************** SSN Start ***************************  -->
      <div 
        class="custom-col socsec ssn-col"
        [ngClass]="
        {
          'order-8 ssn-cobuyer-col': type === 'coBuyer',
          'mb-3' : (personalInfoForm.get('SSN').touched || personalInfoForm.get('SSN').dirty) &&
                   (!personalInfoForm.get('SSN').valid || !!personalInfoForm.get('SSN').errors?.inValidSSN)
        }"
      >
        <label class="an-p-line-height" for="ssn"> {{ SCData?.Ssn1label }}</label>
        <input
          #ssnInput
          [type]="ssnflag || !IE ? 'text' : 'password'"
          class="form-control w-100"
          formControlName="SSN"
          id="ssn"
          autocomplete="off"
          (focus)="checkSecureSSN(false)"
          placeholder="___-__-____"
          (focus)="scrollInto($event)"
          [ngClass]="{
            error:
              (personalInfoForm.get('SSN').touched ||
                personalInfoForm.get('SSN').dirty) &&
              (!personalInfoForm.get('SSN').valid ||
                !!personalInfoForm.get('SSN').errors?.inValidSSN),
            'ssn-custom-mask': !ssnflag && !IE
          }"
          [dtTextMask]="{ mask: ssnMask, guide: ssnflag }"
        />
        
        <button [attr.aria-pressed]="ssnflag ? true : false" aria-label="View SSN"
            class="form-icon-eye dt-icon"
            [ngClass]="ssnflag ? 'dt-icon-eye-open' : 'dt-icon-eye-close'"
            (click)="checkSecureSSN(true);ssnInput.focus();"
            tabindex="0">
        </button>
       
        <button
          tabindex="0" aria-label="Clear SSN" *ngIf="
          (personalInfoForm.get('SSN').touched ||
          personalInfoForm.get('SSN').dirty) &&
          !personalInfoForm.get('SSN').valid"
          class="form-error-x dt-icon dt-icon-input-clear mt-4"
          (click)="personalInfoForm.get('SSN').reset()"
          (keyup)="$event?.keyCode === 13
              ? personalInfoForm.get('SSN').reset()
              : null">
        </button>

        <div class="invalid-feedback d-block">
          <span
            class="form-validator_error"
            *ngIf="
              (personalInfoForm.get('SSN').touched ||
                personalInfoForm.get('SSN').dirty) &&
              (!personalInfoForm.get('SSN').valid ||
                !!personalInfoForm.get('SSN').errors?.inValidSSN)
            "
          >
          <ng-container
              *ngIf="
                !!personalInfoForm.get('SSN').errors?.required;
                else second
              "
            >
              {{ SCData?.Ssn1required }}
            </ng-container>
            <ng-template #second>
              <ng-container *ngIf="personalInfoForm.get('SSN').hasError('cobuyerInvalid') else invalidTemplate">
                {{ SCData?.SSNCobuyerInvalid }}
              </ng-container>
              <ng-template #invalidTemplate >
                <!-- {{ SCData?.Ssn1invalid }} -->
                SSN is invalid
              </ng-template>
            </ng-template>
          </span>
        </div>
      </div>
      <!-- *************************** SSN Start ***************************  -->

      <!-- *************************** SSN Start ***************************  -->
      <div
        class="custom-col socsec2 ssn2-col"
        [ngClass]="{
          'order-8 ssn2-cobuyer-col': type === 'coBuyer'
        }"
      >
        <label class="an-p-line-height" for="SSNConfim"> {{ SCData?.Ssn2label }}</label>
        <input
          [type]="ssnflag || !IE ? 'text' : 'password'"
          class="form-control w-100"
          formControlName="SSNConfim"
          id="SSNConfim"
          (focus)="checkSecureSSN(false)"
          placeholder="___-__-____"
          (focus)="scrollInto($event)"
          [ngClass]="{
            error:
              ((personalInfoForm.get('SSNConfim').touched ||
                personalInfoForm.get('SSNConfim').dirty) &&
                (!personalInfoForm.get('SSNConfim').valid ||
                  !!personalInfoForm.get('SSN').errors?.inValidSSN)) ||
              !!personalInfoForm?.errors?.SSNMatchingError,
            'ssn-custom-mask': !ssnflag && !IE
          }"
          [dtTextMask]="{ mask: ssnMask, guide: ssnflag }"
        />

        <button tabindex="0" [attr.aria-pressed]="ssnflag ? true : false" aria-label="View SSN"
          class="form-icon-eye dt-icon"
          [ngClass]="ssnflag ? 'dt-icon-eye-open' : 'dt-icon-eye-close'"
          (click)="checkSecureSSN(true)">
        </button>

        <button tabindex="0" aria-label="Clear SSN confim" *ngIf="
          (personalInfoForm.get('SSNConfim').touched ||
          personalInfoForm.get('SSNConfim').dirty) &&
          !personalInfoForm.get('SSNConfim').valid"
          class="form-error-x dt-icon dt-icon-input-clear mt-4"
          (click)="personalInfoForm.get('SSNConfim').reset()"
          (keyup)="$event?.keyCode === 13
              ? personalInfoForm.get('SSNConfim').reset()
              : null">
        </button>

        <div class="invalid-feedback d-block">
          <span
            class="form-validator_error"
            *ngIf="
              (personalInfoForm.get('SSNConfim').touched ||
                personalInfoForm.get('SSNConfim').dirty) &&
              (!personalInfoForm.get('SSNConfim').valid ||
                !!personalInfoForm.get('SSNConfim').errors?.inValidSSN)
            "
          >
            <ng-container
              *ngIf="!personalInfoForm.get('SSNConfim').errors?.valid"
            >
              {{ SCData?.Ssn2invalid }}
            </ng-container>
          </span>

          <span
            class="form-validator_error"
            *ngIf="
              (personalInfoForm.get('SSNConfim').touched ||
                personalInfoForm.get('SSNConfim').dirty) &&
              !(
                !personalInfoForm.get('SSNConfim').valid ||
                !!personalInfoForm.get('SSNConfim').errors?.inValidSSN
              ) &&
              !!personalInfoForm?.errors?.SSNMatchingError
            "
          >
            confirm SSN is not matching
          </span>
        </div>
      </div>
      <!-- *************************** SSN Start ***************************  -->
    </div>
  </form>
</div>
<div class="credit-app-cta-section">
  <div class="row m-0 w-100 cta-section">
    <div class="col-12 p-0 d-flex cta-col cta-alignment m-0">
      <button
        id="back_cta"
        type="button"
        class="secondary-cta mr-auto"
        *ngIf="type === 'coBuyer'"
        [disabled]="isSaving"
        (click)="goBack()"
      >
        {{ SCData?.BackCta }}
      </button>
      <button
        id="next_cta"
        class="primary-cta ml-auto"
        [disabled]="!personalInfoForm.valid || isSaving"
        (click)="goNext()"
      >
        {{ SCData?.NextCta }}
      </button>
    </div>
  </div>
</div>
